/* eslint-disable react/jsx-no-useless-fragment */
import React, {Suspense, memo} from "react"
import {useTemplatedComponent, TemplateSettingsModel} from "@next/templating"
import {MANIFEST} from "@manifest/product-summary"
import {TextModel} from "models/Text"
import connect from "./connect"
import useGTMOnHydrate from "../../hooks/useGTMOnHydrate"
import {SuitType, ProductType, SofaType, BundleType} from "../../config/constants"
import {ColourwayData} from "../../models/productSummaryApi"
import {SuitColourwayData} from "../../models/productSummaryApi/suit"
import {SofaColourwayData} from "../../models/productSummaryApi/sofa"
import useCarousel from "../../hooks/useCarousel"

export interface ProductSummaryProps {
    template: TemplateSettingsModel
    text: TextModel
    itemNumber: string
    firstItemNumber: string
    favouriteBtnEnabled: boolean
    productType: typeof SuitType | typeof ProductType | typeof SofaType | typeof BundleType
    enableBrandDisplay: boolean
    brand: string
    colourwaysHasSale: boolean
    colourwaysHasStarRatingWithRangedPrice: boolean
    linkUrl: string
    title: string
    price: string
    colour?: string
    currencyCode: string
    department: string
    tooltipTitle: string
    overallStarRating: number
    ratingText: string
    enableReviewStars: boolean
    enableSingleLineTitle: boolean
    numberOfAllColourways: number
    colourwaysHasRating: boolean
    isConfError?: boolean
    enableSingleLineBrandName: boolean
    client: string
    textAlignment: string
    colourways: ColourwayData[] | SuitColourwayData[] | SofaColourwayData[]
}

const ProductSummaryComponent = (props: ProductSummaryProps) => {
    const Component = useTemplatedComponent(props.template, MANIFEST)
    useGTMOnHydrate(props.itemNumber)
    const {textAlignment, colourways, itemNumber} = props
    const {emblaRef, slideIndex, emblaApi, thumbsEmblaRef, thumbsEmblaApi, thumbsSlideIndex} = useCarousel({
        textAlignment,
        colourways,
        itemNumber,
    })
    return (
        <div id={`plp-product-summary-entrypoint-${props.itemNumber}`} data-pid={props.itemNumber}>
            <section
                data-type="plp_ps_unified"
                className="x-next-plat-mod platform_modernisation_product_summary"
                id={`platform_modernisation_product_summary_${props.itemNumber}`}
            >
                <Suspense>
                    <Component
                        {...{
                            ...props,
                            emblaRef,
                            slideIndex,
                            emblaApi,
                            thumbsEmblaRef,
                            thumbsEmblaApi,
                            thumbsSlideIndex,
                        }}
                    />
                </Suspense>
            </section>
        </div>
    )
}

export const ProductSummary = memo(({isConfError, ...props}: ProductSummaryProps) => {
    return (
        <>
            {isConfError ? (
                <section data-testid="error" className="x-next-plat-mod" />
            ) : (
                <ProductSummaryComponent {...props} />
            )}
        </>
    )
})
ProductSummary.displayName = "ProductSummary"

export default connect(ProductSummary as any)
